import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/bvabhijeeth1999'
      className='link footer__link'
    >
      Created By Venkata Abhijeeth Balabhadruni
    </a>
  </footer>
)

export default Footer
